

class ChunkerSearch {
    constructor(data, quantity) {
        if (!Array.isArray(data)) {
            throw new Error('chunker source is not an array');
            return false;
        }
        
        this.data = data.map((item,idx) => {
            if(typeof item === 'object'){
                item.idx_temp = `${idx}`;
            }
            return item;
        });
        this.index = 0;
        this.length = data.length;
        
        this.quantity = quantity;

    }


    current () {
        if(Array.isArray(this.data)){
            const tmp = [...this.data];
            return {
                "idx": this.index,
                "quantity": this.quantity,
                "items": tmp.slice(this.index, this.index + this.quantity)
            };
        }
    }

    getIndex() {
        return this.index;
    }

    getElementByIdx(index){
        return this.data[index] ? this.data[index] : null 
    }

    setIndex(number){
        this.index = number;
    }

    reset() {
        this.setIndex(0);
        return;
    }

    getAllElements(){
        return this.data;
    }

    updateElementbyIndex = (index, key, newValue)=>{
        if(this.data && this.data[index] && this.data[index][key]){
            this.data[index][key] = newValue;
        }
    }

    isEmpty() {
        return (Array.isArray(this.data) && this.data.length === 0);
    }
};
export default ChunkerSearch;


// WEBPACK FOOTER //
// ./src/containers/Search/ChunkerSearch.js